import { DateTime } from "luxon";
import { clientMutationOptions } from "./controller/clientMutation";

import { ajaxController } from "./controller/AjaxController";
import { DataTableFilteredRequest } from "../components/DataTable/TableHook";
import { PagedResult } from "../DTOs/Common/PagedResult";
import { StoppageCalc } from "../DTOs/Stoppage/StoppageCalc";
import { TripleShift } from "../types/Shift";

export class OperationsAjax {
	private _ajaxController = ajaxController;
	private _operationsDataEndpoint = "/Operations";

	async getStoppageCalcsData(shiftDate: DateTime, dayNightAfternoon: TripleShift, filters: DataTableFilteredRequest) {
		return this._ajaxController.get<PagedResult<StoppageCalc>>(
			// todo: decide if this is the best place to change this value
			`${this._operationsDataEndpoint}/plant/${shiftDate.toISODate()}/${dayNightAfternoon[0]}`,
			filters
		);
	}

	async getStoppageCalcsDataForPlant(shiftDate: DateTime, dayNightAfternoon: TripleShift, plantId: number) {
		return this._ajaxController.get<StoppageCalc>(
			// todo: decide if this is the best place to change this value
			`${this._operationsDataEndpoint}/plant/${shiftDate.toISODate()}/${dayNightAfternoon[0]}/${plantId}`,
			{}
		);
	}

	async updateEngineHours(plantId: number, startHours: number, endHours: number, fuel: number | null, clientId?: string) {
		return this._ajaxController.post<object, StoppageCalc>(
			`${this._operationsDataEndpoint}/engine-hours/${plantId}`,
			{ startHours: startHours, endHours: endHours, fuel: fuel },
			clientMutationOptions(clientId)
		);
	}

	async completeShift(shiftDate: DateTime, dayNightAfternoon: TripleShift) {
		return this._ajaxController.post<object, object>(
			`${this._operationsDataEndpoint}/complete-shift/${shiftDate.toISODate()}/${dayNightAfternoon[0]}`,
			{}
		);
	}

	async updateOperationLocation(operationId: number, newLocationId: number, clientId?: string) {
		return this._ajaxController.post<object, StoppageCalc>(
			`${this._operationsDataEndpoint}/update-location/${operationId}`,
			{ newLocationId },
			clientMutationOptions(clientId)
		);
	}
}

export const operationsAjax = new OperationsAjax();